import ProductCard, { Product } from './ProductCard';

interface ProductGridProps {
  products: Product[];
  loading?: boolean;
  highlightedIds?: string[];
  onProductClick?: (product: Product) => void;
}

function ProductSkeleton() {
  return (
    <div className="bg-card border border-primary/10 rounded-xl overflow-hidden animate-pulse">
      <div className="aspect-square bg-primary/5" />
      <div className="p-4 space-y-3">
        <div className="h-3 bg-primary/5 rounded w-1/3" />
        <div className="h-4 bg-primary/5 rounded w-full" />
        <div className="h-4 bg-primary/5 rounded w-2/3" />
        <div className="h-3 bg-primary/5 rounded w-1/4" />
        <div className="flex justify-between items-center pt-2">
          <div className="h-6 bg-primary/5 rounded w-1/3" />
          <div className="h-8 w-8 bg-primary/5 rounded-lg" />
        </div>
      </div>
    </div>
  );
}

export default function ProductGrid({ products, loading, highlightedIds = [], onProductClick }: ProductGridProps) {
  if (loading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
        {Array.from({ length: 8 }).map((_, i) => (
          <ProductSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">Geen producten gevonden</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-section="products">
      {products.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
          highlighted={highlightedIds.includes(product.id)}
          onClick={onProductClick ? () => onProductClick(product) : undefined}
        />
      ))}
    </div>
  );
}
